export default __webpack_public_path__ + "static/media/error.0da7acf4.wav";